import { MutationFunction, QueryFunction, QueryKey, useMutation, UseMutationOptions, useQuery, UseQueryOptions } from 'react-query';
import { UseHttpClient, useHttpClient } from './httpclient';

export const useBaseMutation =
	<TData = unknown, TQueryFnData = unknown, TError = unknown>(client: UseHttpClient) =>
	(queryKey: QueryKey, queryFn: () => MutationFunction<TQueryFnData>, options?: UseMutationOptions<TQueryFnData, TError, TData>) => {
		const basem = useMutation<TQueryFnData, TError, TData>(queryKey, queryFn(), { ...options });
		return { ...basem, abort: () => client.abort() };
	};

interface UseBaseQuery<TData = unknown, TQueryFnData = unknown, TError = unknown> {
	queryKey: QueryKey;
	queryFn: () => QueryFunction<TQueryFnData>;

	abortFn?: () => void;
	options?: UseQueryOptions<TQueryFnData, TError, TData>;
}
export const useBaseQuery = <TResponse = unknown, TRequest = unknown, TError = unknown>(
	props: UseBaseQuery<TResponse, TRequest, TError>
) => {
	const baseq = useQuery<TRequest, TError, TResponse>(props.queryKey, props.queryFn(), {
		refetchOnWindowFocus: false,
		...props.options,
		cacheTime: 0
	});
	return { ...baseq, abort: props.abortFn };
};
